module.exports = __webpack_public_path__ + "static/media/free-gift-item.8b1dc594.jpeg";